import React from 'react';
import { ListGroup } from 'react-bootstrap';
import ProjectPlaceholder from '../ProjectPlaceholder';
import { Star } from 'lucide-react';

export default class DeviceList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            favourites: localStorage.getItem('favourites') ? JSON.parse(localStorage.getItem('favourites')) : []
        };
    }

    renderList() {
        return this.props.devices.map(device => {
            const isFavourite = this.state.favourites.map(f => f.xmlRef).indexOf(device.xmlRef) > -1;
            const handleClick = () => {
                this.setState((oldState) => {
                    const newState = {
                        favourites: !isFavourite ?
                            [...oldState.favourites, { xmlRef: device.xmlRef }] :
                            oldState.favourites.filter((item) => item.xmlRef !== device.xmlRef)
                    }
                    localStorage.setItem('favourites', JSON.stringify(newState.favourites));
                    return newState;
                })
            };
            return (
                <ListGroup.Item
                    key={device.id}
                    eventKey={device.id}
                    onClick={(e) => this.props.onShowDevice(e, device)} >
                    {isFavourite ? <Star onClick={handleClick} style={{ color: 'gold' }} fill="gold"></Star> : <Star onClick={handleClick}></Star>}
                    {device.deviceTypeName}
                </ListGroup.Item>
            );
        });
    }

    render() {

        if (!this.props.devices) {
            //return null;
            return (<ProjectPlaceholder />);
        }

        return (
            <ListGroup activeKey={this.props.activeKey} className="device-list-group">
                {this.renderList()}
            </ListGroup>
        );
    }
}
